export const DUPLICATE_SCRIBE = 'DUPLICATE_SCRIBE';
export const DUPLICATE_SCRIBE_START = 'DUPLICATE_SCRIBE_START';
export const DUPLICATE_SCRIBE_SUCCESS = 'DUPLICATE_SCRIBE_SUCCESS';
export const DUPLICATE_SCRIBE_FAILED = 'DUPLICATE_SCRIBE_FAILED';

export const duplicateScribe = scribeId => ({
  type: DUPLICATE_SCRIBE,
  scribeId,
  createdDate: new Date()
});

export const duplicateScribeStart = loadingScribe => ({
  type: DUPLICATE_SCRIBE_START,
  loadingScribe
});

export const duplicateScribeSuccess = (scribe, loadingId) => ({
  type: DUPLICATE_SCRIBE_SUCCESS,
  scribe,
  loadingId
});

export const duplicateScribeFailed = loadingId => ({
  type: DUPLICATE_SCRIBE_FAILED,
  loadingId
});
